module.exports = __webpack_public_path__ + "static/media/14.e0124109.png";